import type { UserProfile } from '@bcc/shared';
import { ROLES } from '@bcc/shared';

function isAdminOrStaffPortalPath(path: string): boolean {
  return path === '/admin' || path.startsWith('/admin/') || path === '/staff' || path.startsWith('/staff/');
}

function isInvestorPortalPath(path: string): boolean {
  return (
    path === '/dashboard' ||
    path.startsWith('/dashboard/') ||
    path === '/account' ||
    path.startsWith('/account/')
  );
}

/**
 * Where to send the user immediately after sign-in (or when visiting `/login` while already authenticated).
 * Admins default to `/admin`; investors to `/dashboard`; staff to `/staff`. Honors safe deep links only.
 */
export function resolvePostLoginRoute(redirect: string | undefined, role: UserProfile['role']): string {
  const r = redirect?.trim();
  const blocked = !r || r === '/login' || r === '/register' || r === '/getstarted';

  if (role === ROLES.ADMIN) {
    if (!blocked && isAdminOrStaffPortalPath(r)) return r;
    return '/admin';
  }
  if (role === ROLES.STAFF) {
    if (!blocked && (isAdminOrStaffPortalPath(r) || isInvestorPortalPath(r))) return r;
    return '/staff';
  }
  if (!blocked && isInvestorPortalPath(r)) return r;
  return '/dashboard';
}
